import { useFormContext, useWatch } from 'react-hook-form';
import type { IGetMilestonesServiceRes } from '@/api/Sherpa/Project/modules/ProjectTdm/types';
import { HookReactSingleSelect } from '@/components/UI/HookForm/Form/ReactSelect';
import { useMilestones } from '@/hooks/ReactQueryHooks/useMilestonesQuery';
import useUpdateEffect from '@/hooks/useUpdateEffect';
import { capitalize, formatDate3 } from '@/utils';
import type { MilestoneChangeOrderSchema } from '../MilestoneForm/validationSchema';

export function MilestoneSelect({ projectId, isDisabled }: { projectId: string; isDisabled?: boolean }) {
  const formMethods = useFormContext<MilestoneChangeOrderSchema>();
  const phase = useWatch({
    name: 'phase',
    control: formMethods.control,
  });
  const milestone = useWatch({
    name: 'milestone',
    control: formMethods.control,
  });

  const { data } = useMilestones({
    params: {
      page: 1,
      perPage: 10,
      project_id: Number(projectId),
      phase: phase?.value,
    },
  });

  const milestones = data as IGetMilestonesServiceRes | undefined;
  const milestoneOptions = milestones?.data.map((milestone) => ({
    label: milestone.name,
    value: String(milestone.id),
    dueDate: milestone.dueDate,
  }));

  useUpdateEffect(() => {
    console.log(milestone);
    const currentMilestone = milestones?.data.find((option) => String(option.id) === String(milestone?.value));

    if (currentMilestone) {
      formMethods.setValue('proposedDueDate', formatDate3(currentMilestone.dueDate, 'yyyy-mm-dd'));
      formMethods.setValue('dueDate', formatDate3(currentMilestone.dueDate, 'yyyy-mm-dd'));

      const { phase } = formMethods.getValues();

      if (!phase) {
        formMethods.setValue('phase', {
          label: capitalize(currentMilestone.phase),
          value: currentMilestone.phase.toUpperCase(),
        });
      }
    }
  }, [milestone]);

  return (
    <HookReactSingleSelect
      formMethods={formMethods}
      label='Milestone'
      options={milestoneOptions}
      placeholder=''
      isDisabled={isDisabled}
      name='milestone'
    />
  );
}
